import type { Palette, TypographyVariantsOptions } from '@mui/material/styles';

/** One family everywhere; hierarchy comes from size, weight and tracking alone. */
export const fonts = { sans: '"Geist", "SF Pro Text", "Helvetica Neue", Arial, sans-serif' } as const;

const display = { fontWeight: 600, textWrapStyle: 'balance' } as const;

export const typography = (palette: Palette): TypographyVariantsOptions => ({
  fontFamily: fonts.sans,
  fontWeightMedium: 500,
  h1: { ...display, fontSize: '1.875rem', lineHeight: 1.15, letterSpacing: '-0.03em' },
  h2: { ...display, fontSize: '1.5rem', lineHeight: 1.2, letterSpacing: '-0.025em' },
  h3: { fontSize: '1.0625rem', fontWeight: 600, lineHeight: 1.35, letterSpacing: '-0.012em' },
  h4: { fontSize: '1rem', fontWeight: 600, letterSpacing: '-0.01em' },
  h5: { fontSize: '0.9375rem', fontWeight: 600 },
  h6: { fontSize: '0.875rem', fontWeight: 600 },
  subtitle1: { fontSize: '0.9375rem', fontWeight: 600, letterSpacing: '-0.005em' },
  subtitle2: { fontSize: '0.8125rem', fontWeight: 500, color: palette.text.secondary },
  body1: { fontSize: '0.9375rem', lineHeight: 1.6 },
  body2: { fontSize: '0.8125rem', lineHeight: 1.55 },
  caption: { fontSize: '0.75rem', lineHeight: 1.5, color: palette.text.secondary },
  overline: { fontSize: '0.6875rem', fontWeight: 600, letterSpacing: '0.06em', lineHeight: 1.6 },
  button: { textTransform: 'none', fontWeight: 500, letterSpacing: '-0.005em' },
});
